export const SUCCESS = "SUCCESS";
export const FAILURE = "FAILURE";

export const GET = "GET";
export const POST = "POST";
export const PUT = "PUT";

export const QUERY_INSERT = 1;
export const QUERY_UPDATE = 2;

export const API_BASE_URL = "https://gestiondeflota.boltrack.net/api-gestion-plataforma";
// export const API_BASE_URL = "http://localhost:9101";